export default __webpack_public_path__ + "static/media/cladding22.a618c264.jpg";